module.exports = __webpack_public_path__ + "static/img/GettyImages-170998531.166756d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-170998531.jpg
// module id = OkeJ
// module chunks = 0